import { brandApi } from "@/lib/axios";

export interface MetaAdsStatus {
  connected: boolean;
  deauthorized?: boolean;
  metaUserId: string | null;
  defaultAdAccountId: string | null;
  defaultFacebookPageId: string | null;
  metaPixelId: string | null;
  tokenExpiresAt: string | null;
  deauthorizedAt?: string | null;
}

export async function getMetaAdsStatus(): Promise<MetaAdsStatus> {
  const { data } = await brandApi.get<MetaAdsStatus>("/meta-ads/status");
  return data;
}

export async function getMetaOauthUrl(): Promise<{ url: string }> {
  const { data } = await brandApi.get<{ url: string }>("/meta-ads/oauth/url");
  return data;
}

export async function disconnectMetaAds(): Promise<{ disconnected: boolean }> {
  const { data } = await brandApi.delete<{ disconnected: boolean }>(
    "/meta-ads/connection",
  );
  return data;
}

export async function setDefaultAdAccount(
  defaultAdAccountId: string,
): Promise<{ defaultAdAccountId: string }> {
  const { data } = await brandApi.put<{ defaultAdAccountId: string }>(
    "/meta-ads/default-ad-account",
    { defaultAdAccountId },
  );
  return data;
}

export async function setMetaConversionsPixel(
  metaPixelId: string,
): Promise<{ metaPixelId: string | null }> {
  const { data } = await brandApi.put<{ metaPixelId: string | null }>(
    "/meta-ads/conversions-pixel",
    { metaPixelId },
  );
  return data;
}

export async function fetchAdAccounts(params?: Record<string, string>) {
  const { data } = await brandApi.get<unknown>("/meta-ads/ad-accounts", {
    params,
  });
  return data;
}

export async function fetchFacebookPages() {
  const { data } = await brandApi.get<unknown>("/meta-ads/facebook-pages");
  return data;
}

export async function setDefaultFacebookPage(
  defaultFacebookPageId: string,
): Promise<{ defaultFacebookPageId: string }> {
  const { data } = await brandApi.put<{ defaultFacebookPageId: string }>(
    "/meta-ads/default-facebook-page",
    { defaultFacebookPageId },
  );
  return data;
}

export async function fetchCampaigns(params?: Record<string, string>) {
  const { data } = await brandApi.get<unknown>("/meta-ads/campaigns", {
    params,
  });
  return data;
}

export async function fetchAdsets(
  campaignId: string,
  params?: Record<string, string>,
) {
  const { data } = await brandApi.get<unknown>(
    `/meta-ads/campaigns/${campaignId}/adsets`,
    { params },
  );
  return data;
}

export async function fetchAds(adsetId: string, params?: Record<string, string>) {
  const { data } = await brandApi.get<unknown>(
    `/meta-ads/adsets/${adsetId}/ads`,
    { params },
  );
  return data;
}

/**
 * Graph insights for an ad account (`act_…`), campaign, ad set or ad. Pass
 * Graph params through: `fields`, `date_preset`, `level`, `time_increment`.
 */
export async function fetchInsights(objectId: string, params?: Record<string, string>) {
  const { data } = await brandApi.get<unknown>(`/meta-ads/insights/${objectId}`, { params });
  return data;
}
